import { render, staticRenderFns } from "./JciProgramList.vue?vue&type=template&id=5c3cc0b0&scoped=true"
import script from "./JciProgramList.vue?vue&type=script&lang=js"
export * from "./JciProgramList.vue?vue&type=script&lang=js"
import style0 from "./JciProgramList.vue?vue&type=style&index=0&id=5c3cc0b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3cc0b0",
  null
  
)

export default component.exports